interface UserMessageProps {
  message: string;
}

/**
 * User Message Component (Production)
 *
 * Kit-aligned user bubble — ink background, cream-soft text, Geist body
 * typography. The 16px radius with a flattened tr corner (`rounded-tr-md`
 * instead of `-tr-none`) softens the "chat tail" so the bubble reads as
 * a kit chip rather than a hard arrow.
 */
export function UserMessage({ message }: UserMessageProps) {
  return (
    <div className="pl-6 flex-col justify-start items-start gap-2.5 flex self-end max-w-[80%]">
      <div
        className="px-3.5 py-2.5 rounded-2xl rounded-tr-md whitespace-pre-wrap break-words"
        style={{
          background: "var(--d-ink)",
          color: "#F6F2EE",
          fontFamily: "var(--d-font-body)",
          fontSize: 13.5,
          lineHeight: 1.5,
          letterSpacing: "-0.003em",
        }}
      >
        {message}
      </div>
    </div>
  );
}
